import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";


function Reviews() {
    const { rpdata } = useContext(GlobalDataContext);
    return (
        <BaseLayout PageName="Reviews">
            <div className="md:max-w-full w-full">
                <TransparentHeader
                    headertitle="Reviews"
                    Subheader="Reviews"
                    bgimg={`${rpdata?.stock?.[2]}`}
                    // para cambiar el svg del header busquemos en la carpeta css y buscamos el archivo de svgStyles
                    // los estilo de svg para el header empiezan svgTranspareHeader seguido de un numero
                    svgClass='svgTranspareHeader2'

                />
            </div>
            <div className="w-4/5 mx-auto py-[100px]">
                <h1 className="text-center pb-10">{rpdata?.labels?.general?.titleReviews}</h1>
                <review-widget widgetId="557c43d4-e983-415f-a765-98c1c5ccbbd9"></review-widget>
            </div>
        </BaseLayout>
    );
}

export default Reviews;
